module.exports = __webpack_public_path__ + "img/mmlz18.e2275376.jpg";